export default "__VITE_PUBLIC_ASSET__83c712ad__"